export default {"src":"/_next/static/media/0xf417f5a458ec102b90352f697d6e2ac3a3d2851f.fc08aec8.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};